import Immutable from "immutable";
import * as types from "./constants";

const initialState = Immutable.fromJS({
  processLogIndexCheckedArray: [],
  formData: [],
  modalData: {},
  modalDataDetails: [],
  jsonModalData: { lhs: {}, rhs: {} },
  formDataJSON: {},
  tabularized: {},
  devices: [],
  submissionErrors: [],
  rangeFilter: "1 Months",
  errorFilter: "",
  searchFilter: "",
  serverSearchFilter: "",
  isFetchingFormDataJSON: false,
  jsonFormModalOpen: false,
  changeModalOpen: false,
  changeOrderSubmissionID: -1,
  recallToDeviceModalOpen: false,
  isDeleteConfirmationOpen: false,
  recallDeviceResponse: {},
  isRecallingToDevice: false,
  isRecallToDeviceStatusModalOpen: false,
  makeTemplateDeviceResponse: {},
  makeTemplateToDeviceModalOpen: false,
  isSendingTemplateToDevice: false,
  isMakeTemplateToDeviceStatusModalOpen: false,
  deviceSelected: { device: "", type: "" },
  processLogSelectedRowIndex: 0,
  isFetchingDevices: false,
  isUpdatingProcessLog: false,
  processLogNewStatus: "",
  newSubmissionDateTime: "",
  formJsonModalSearchText: "",
  jsonModalDisplayLevels: 3,
  rowsUpdating: Immutable.Set(),
  isFetchingErrorList: false
});

function handleAction(state = initialState, action) {
  switch (action.type) {
    case types.SUBMISSION_SET_CHANGE_ORDER_SUBMISSION_ID:
      return state.set(
        "changeOrderSubmissionID",
        Immutable.fromJS(action.payload)
      );

    case types.SUBMISSION_DEVICES_FETCH_REQUEST:
      return state.set("isFetchingDevices", true);

    case types.SUBMISSION_DEVICES_FETCH_SUCCESS:
      return state.merge({
        isFetchingDevices: false,
        devices: Immutable.fromJS(action.payload.devices)
      });
    case types.SUBMISSION_DEVICES_FETCH_ERROR:
      return state.merge({
        recallToDeviceModalOpen: false,
        isFetchingDevices: false
      });

    case types.SUBMISSION_RECALL_CONFIRM_MODAL_CLOSE:
      return state.merge({
        recallToDeviceModalOpen: false,
        isRecallToDeviceStatusModalOpen: false,
        detailsModalOpen: false
      });

    case types.SUBMISSION_RECALL_MODAL_OPEN:
      return state.set("recallToDeviceModalOpen", true);

    case types.SUBMISSION_RECALL_MODAL_CLOSE:
      return state.set("recallToDeviceModalOpen", false);

    case types.SUBMISSION_RECALL_SET_DEVICE:
      return state.set("deviceSelected", Immutable.fromJS(action.payload));

    case types.SUBMISSION_RECALL_DEVICE_REQUEST:
      return state.merge({
        isRecallToDeviceStatusModalOpen: true,
        isRecallingToDevice: true
      });

    case types.SUBMISSION_RECALL_DEVICE_SUCCESS:
      return state.merge({
        isRecallingToDevice: false,
        recallDeviceResponse: Immutable.fromJS(action.payload)
      });

    case types.SUBMISSION_SEND_TEMPLATE_CONFIRM_MODAL_CLOSE:
      return state.merge({
        makeTemplateToDeviceModalOpen: false,
        isMakeTemplateToDeviceStatusModalOpen: false,
        detailsModalOpen: false
      });

    case types.SUBMISSION_MAKE_TEMPLATE_MODAL_OPEN:
      return state.set("makeTemplateToDeviceModalOpen", true);

    case types.SUBMISSION_MAKE_TEMPLATE_MODAL_CLOSE:
      return state.set("makeTemplateToDeviceModalOpen", false);

    case types.SUBMISSION_MAKE_TEMPLATE_SET_DEVICE:
      return state.set(
        "deviceSelected",
        Immutable.fromJS(action.payload.device)
      );

    case types.SUBMISSION_SEND_TEMPLATE_DEVICE_REQUEST:
      return state.merge({
        isMakeTemplateToDeviceStatusModalOpen: true,
        isSendingTemplateToDevice: true
      });

    case types.SUBMISSION_SEND_TEMPLATE_DEVICE_SUCCESS:
      return state.merge({
        isSendingTemplateToDevice: false,
        makeTemplateDeviceResponse: Immutable.fromJS(action.payload)
      });

    case types.SUBMISSION_CHANGE_MODAL_OPEN:
      return state.set("changeModalOpen", true);

    case types.SUBMISSION_CHANGE_MODAL_CLOSE:
      return state.merge({
        changeModalOpen: false,
        changeOrderSubmissionID: -1
      });
    case types.SUBMISSION_CHANGE_ORDER_ERROR:
      return state.set("changeModalOpen", false);

    case types.SUBMISSION_DELETE_CONFIRM_MODAL_OPEN:
      return state.set("isDeleteConfirmationOpen", true);

    case types.SUBMISSION_DELETE_CONFIRM_MODAL_CLOSE:
      return state.set("isDeleteConfirmationOpen", false);

    case types.SUBMISSION_FORM_DATA_MODAL_OPEN:
      return state.set("jsonFormModalOpen", true);

    case types.SUBMISSION_SET_FORM_DATA_SEARCH_TEXT:
      return state.set("formJsonModalSearchText", action.payload);

    case types.SUBMISSION_FORM_DATA_MODAL_CLOSE:
      return state.merge({
        jsonFormModalOpen: false,
        jsonModalDisplayLevels: 3
      });

    case types.SUBMISSION_FORM_DATA_FETCH_REQUEST:
      return state.set("isFetchingFormDataJSON", true);

    case types.SUBMISSION_FORM_DATA_FETCH_SUCCESS:
      return state.merge({
        formDataJSON: Immutable.fromJS(action.payload.formData || {}),
        tabularized: Immutable.fromJS(action.payload.tabularized || {}),
        isFetchingFormDataJSON: false
      });

    case types.SUBMISSION_FORM_DATA_FETCH_ERROR:
      return state.merge({
        isFetchingFormDataJSON: false,
        jsonFormModalOpen: false
      });

    case types.SUBMISSION_FORM_SOURCE_FETCH_SUCCESS:
      return state.set("isFetchingFormSource", false);
    case types.SUBMISSION_FORM_SOURCE_FETCH_ERROR:
      return state.set("isFetchingFormSource", false);

    case types.SUBMISSION_UPDATE_ROW:
      return state.setIn(
        [
          "formData",
          state
            .get("formData")
            .toJS()
            .findIndex(f => f.submission_id === action.payload.submission_id)
        ],
        Immutable.fromJS(action.payload)
      );

    case types.SUBMISSION_DETAILS_MODAL_OPEN:
      return state.merge({
        processLogIndexCheckedArray: Immutable.fromJS([]),
        detailsModalOpen: true,
        processLogToggleSelectAll: false
      });

    case types.SUBMISSION_DETAIL_MODAL_ADD_CHECKED_INDEX:
      return state.withMutations(s =>
        s
          .update("processLogIndexCheckedArray", x =>
            x.toSet().add(action.payload)
          )
          .update("processLogToggleSelectAll", () => false)
      );

    case types.SUBMISSION_DETAIL_MODAL_REMOVE_CHECKED_INDEX:
      return state.withMutations(s =>
        s
          .update("processLogIndexCheckedArray", x =>
            x.toSet().delete(action.payload)
          )
          .update("processLogToggleSelectAll", () => false)
      );

    case types.SUBMISSION_DETAILS_MODAL_CLOSE:
      return state.merge({
        detailsModalOpen: false,
        processLogToggleSelectAll: false,
        processLogIndexCheckedArray: [],
        processLogNewStatus: ""
      });

    case types.SUBMISSION_PROCESS_LOG_INVALIDATE:
      return state.set("modalDataDetails", Immutable.fromJS([]));

    case types.SUBMISSION_PROCESS_LOG_UPDATE_REQUEST:
      return state.merge({
        isUpdatingProcessLog: true
      });

    case types.SUBMISSION_PROCESS_LOG_UPDATE_SUCCESS:
      return state.merge({
        isFetchingModalDetails: false,
        processLogNewStatus: "",
        processLogIndexCheckedArray: [],
        processLogToggleSelectAll: false
      });

    case types.SUBMISSION_PROCESS_LOG_UPDATE_ERROR:
      return state.merge({
        detailsModalOpen: false,
        isUpdatingProcessLog: false,
        isFetchingModalDetails: false
      });

    case types.SUBMISSION_ERROR_LIST_REQUEST:
      return state.merge({
        isFetchingErrorList: true
      });

    case types.SUBMISSION_ERROR_LIST_SUCCESS:
      return state.merge({
        submissionErrors: action.payload || [],
        isFetchingErrorList: false
      });

    case types.SUBMISSION_OPEN_JSON_MODAL:
      return state.merge({
        processLogSelectedRowIndex: Immutable.fromJS(action.payload),
        jsonModalOpen: true
      });

    case types.SUBMISSION_CLOSE_JSON_MODAL:
      return state.merge({
        jsonModalOpen: false,
        processLogSelectedRowIndex: 0
      });

    case types.SUBMISSION_UPDATE_STORED_PROCESS_LOG:
      return state.setIn(
        ["modalDataDetails", action.payload.index],
        action.payload.data
      );

    case types.SUBMISSION_UPDATING_ROW:
      return state.set(
        "rowsUpdating",
        state.get("rowsUpdating").add(action.payload)
      );

    case types.SUBMISSION_SUCCESS_ROW:
      return state.set(
        "rowsUpdating",
        state.get("rowsUpdating").delete(action.payload)
      );
    case types.SUBMISSION_ERROR_ROW:
      return state.set("rowsUpdating", Immutable.Set());

    case types.SUBMISSION_UPDATE_STORED_PROCESS_FORM:
      return state.withMutations(s =>
        s.set("isUpdatingProcessLog", false).setIn(
          [
            "formData",
            state
              .get("formData")
              .toJS()
              .map(d => d.submission_id)
              .indexOf(action.payload.submission_id),
            "process_form"
          ],
          action.payload.process_form
        )
      );

    case types.SUBMISSION_SEARCH_FILTER:
      return state.set("searchFilter", Immutable.fromJS(action.payload));

    case types.SUBMISSION_SERVER_SEARCH_FILTER:
      return state.set("serverSearchFilter", Immutable.fromJS(action.payload));

    case types.SUBMISSION_SERVER_SEARCH_FILTER_SUCCESS:
      return state.set(
        "arrayOfSubmissionIDs",
        Immutable.fromJS(action.payload)
      );

    case types.SUBMISSION_DETAILS_MODAL_SET_DATA:
      return state.set("modalData", Immutable.fromJS(action.payload.modalData));

    case types.SUBMISSION_RANGE_FILTER:
      return state.set("rangeFilter", Immutable.fromJS(action.payload));

    case types.SUBMISSION_ERROR_FILTER:
      return state.set("errorFilter", Immutable.fromJS(action.payload));

    case types.SUBMISSION_PROCESS_LOG_SET_ACTION:
      return state.set("processLogNewStatus", Immutable.fromJS(action.payload));

    case types.SUBMISSION_PROCESS_LOG_TOGGLE_SELECT_ALL:
      return state.withMutations(s =>
        s
          .update("processLogToggleSelectAll", () => action.payload.status)
          .set(
            "processLogIndexCheckedArray",
            Immutable.fromJS(action.payload.indexArray)
          )
      );

    case types.SUBMISSION_PROCESS_LOG_FETCH_REQUEST:
      return state.set("isFetchingModalDetails", true);

    case types.SUBMISSION_PROCESS_LOG_FETCH_SUCCESS:
      return state.merge({
        isFetchingModalDetails: false,
        modalDataDetails: Immutable.fromJS(action.payload.processLogData)
      });

    case types.SUBMISSION_PROCESS_LOG_FETCH_ERROR:
      return state.merge({
        isDeleteConfirmationOpen: false,
        isFetchingModalDetails: false,
        detailsModalOpen: false,
        isUpdatingProcessLog: false,
        rowsUpdating: Immutable.Set()
      });

    case types.SUBMISSION_CHANGE_JSON_LEVELS_VIEW:
      return state.set("jsonModalDisplayLevels", action.payload);

    case types.SUBMISSION_DATA_FETCH_REQUEST:
      return state.merge({
        isFetching: true
      });
    case types.SUBMISSION_DATA_FETCH_SUCCESS:
      return state.merge({
        isFetching: false,
        formData: Immutable.fromJS(action.payload.formSubmissions)
      });
    case types.SUBMISSION_DATA_FETCH_ERROR:
      return state.merge({
        isFetching: false
      });

    default:
      return state;
  }
}

function fieldNotNull(value) {
  return !(typeof value === "undefined" || !value);
}

export function updateUrl(state) {
  const paramObj = new URLSearchParams();
  const validFields = [
    "rangeFilter",
    "errorFilter",
    "searchFilter",
    "serverSearchFilter"
  ];

  // eslint-disable-next-line no-restricted-syntax
  for (const k of Array.from(state.keys()).filter(
    key => validFields.includes(key) && fieldNotNull(state.get(key))
  )) {
    paramObj.append(k, state.get(k));
  }

  const baseUrl = window.location.href.split("?")[0];
  const newUrl = `${baseUrl}?${paramObj.toString()}`;

  if (newUrl !== window.location.href) {
    window.history.pushState({}, "", `${baseUrl}?${paramObj.toString()}`);
  }
}

function statusReducer(state = initialState, action) {
  const updatedState = handleAction(state, action);

  if (state !== updatedState) {
    updateUrl(updatedState);
  }
  return updatedState;
}

export default statusReducer;
